module.exports = __webpack_public_path__ + "img/fig14.af466f8f.jpg";